export default __webpack_public_path__ + "static/media/new-games.a768d895.svg";